import { IBarometerData, IBarometerPointsDetails } from '../common/interfaces/barometer.interface';

const emptyTargetLevelDataObject: IBarometerPointsDetails = {
  open: 0,
  paid: 0,
  previousMonth: 0,
  previousMonthDifference: 0,
  previousMonthDifferenceInPercent: 0,
  previousYear: 0,
  previousYearDifference: 0,
  previousYearDifferenceInPercent: 0,
};

export default {
  overview: {
    current: 0,
    nextTargetLevel: {
      customerRevenue: {
        internalTitle: ``,
        value: 0,
      },
      customerRevenue2: {
        internalTitle: ``,
        value: 0,
      },
      teamRevenue: {
        internalTitle: ``,
        value: 0,
      },
      teamRevenue1: {
        internalTitle: ``,
        value: 0,
      },
      teamRevenue2: {
        internalTitle: ``,
        value: 0,
      },
      teamRevenue3: {
        internalTitle: ``,
        value: 0,
      },
    },
  },
  points: {
    customerRevenue: emptyTargetLevelDataObject,
    newPartnerVolume: emptyTargetLevelDataObject,
    teamRevenue: emptyTargetLevelDataObject,
    teamRevenue1: emptyTargetLevelDataObject,
    teamRevenue2: emptyTargetLevelDataObject,
    teamRevenue3: emptyTargetLevelDataObject,
  },
} as IBarometerData;
